<template>
  <AiSummary
    :response="cachedData || aiSummaryDetail"
    :is-initial-loading="!cachedData && isInitialLoading"
    :is-error="isError"
    :question-list="BLOCK_AI_QUESTION_LIST"
    :selected-question-type="questionType"
    :show-typing-animation="showTypingAnimation"
  />
</template>

<script setup lang="ts">
import { useQueryClient } from '@tanstack/vue-query'

import { aiSummaryService } from '~/api/service/ai-summary.service'
import { useFetchBlockDetail } from '~/api/service/block/[blockNumber]/index.service'
import { aiSummaryKey } from '~/api/service/query-keys.const'
import AiSummary from '~/components/ai-summary/AiSummary.vue'
import { BLOCK_AI_QUESTION_LIST } from '~/constants/ai-summary.constants'
import { aiQuestionType, aiSummaryDataType, IAiSummaryRequestParam } from '~/types/ai-summary.type'
import { getRouteParam } from '~/utils/route.util'

const queryClient = useQueryClient()
const blockNumber = getRouteParam('blockNumber')
const { data: blockDetail } = useFetchBlockDetail(blockNumber)

const showTypingAnimation = ref(true)

const questionType = ref<aiQuestionType>(aiQuestionType.SUMMARY)

const param = computed((): IAiSummaryRequestParam => {
  return {
    question: questionType.value,
    dataType: aiSummaryDataType.BLOCK,
  }
})

const { data: aiSummaryDetail, isError, isInitialLoading } = aiSummaryService.useGetAiSummary(param, blockDetail)

const cachedData = computed(() => {
  return queryClient.getQueryState([ ...aiSummaryKey, param.value, blockDetail.value ])?.data
})

watch(() => cachedData.value, () => {
  showTypingAnimation.value = !cachedData.value
}, { immediate: true })
</script>

<style scoped lang="scss">

</style>